import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { useEffect, useMemo, useState } from "react";
import { MdOutlineRemoveRedEye } from "react-icons/md";
import { viewProviderTool } from "../../Services/Provider/providerService";
import EditProvider from "./EditProviderTool";
import Dialog from "../../Components/Modal/Dialog";
import { useNavigate } from "react-router-dom";
import Loader from "../Loader";
import GeneralToast from "../Toaster";

const ViewProvider = () => {
  const [isViewProvider, setIsViewProvider] = useState(false);
  const [selectedProvider, setSelectedProvider] = useState();
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const navigate = useNavigate();
  const columnDefs = useMemo(
    () => [
      {
        field: "id",
        headerCheckboxSelection: false,
        checkboxSelection: false,
        showDisabledCheckboxes: false,
        headerName: "Provider ID",
        width: 420,
      },
      { field: "name", headerName: "Provider Name", width: 300 },
      { field: "type", headerName: "Provider Type", width: 300 },
      {
        field: "view",
        headerName: "View Provider",
        cellRenderer: (params) => {
          return (
            <div className="flex items-center h-full">
              <MdOutlineRemoveRedEye
                onClick={() => {
                  setIsViewProvider(true);
                  setSelectedProvider(params.data);
                }}
                style={{
                  color: "#47B7CF",
                  fontSize: "large",
                  cursor: "pointer",
                }}
              />
            </div>
          );
        },
        width: 200,
      },
      {
        field: "viewtools",
        headerName: "View Tools",
        cellRenderer: (params) => {
          return (
            <div className="flex items-center h-full">
              <MdOutlineRemoveRedEye
                onClick={() => {
                  navigate(`/provider/tool/view/?providerId=${params.data.id}`);
                }}
                style={{
                  color: "#47B7CF",
                  fontSize: "large",
                  cursor: "pointer",
                }}
              />
            </div>
          );
        },
        width: 200,
      },
    ],
    [navigate]
  );

  const fetchProviders = () => {
    setIsLoading(true);
    setErrorMessage("");
    const payload = {
      input: {
        entityType: "Provider",
        property: "id",
        value: "1",
        operator: "neq",
      },
    };
    viewProviderTool(payload)
      .then((res) => {
        setIsLoading(false);
        if (res?.data?.status === 200) {
          const providers = res?.data?.data?.map((provider) => ({
            ...provider.Provider,
          }));
          setData(providers);
        } else {
          setData([]);
          setErrorMessage(
            res?.response?.data?.errorMessage ||
              res?.message ||
              "Something went wrong"
          );
        }
      })
      .catch((err) => {
        setIsLoading(false);
        setErrorMessage("Something went wrong");
      });
  };

  useEffect(() => {
    fetchProviders();
  }, []);

  const defaultColDef = useMemo(
    () => ({
      filter: true,
      sortable: true,
    }),
    []
  );

  const onCloseViewProvider = (position) => {
    setIsViewProvider(false);
    if (position === "success") {
      fetchProviders();
    }
  };

  return (
    <>
      {isLoading && <Loader />}
      <p className="flex items-center justify-center mt-20 mb-4 text-lg text-[#0e76a8]">
        <b>View Providers</b>
      </p>
      <div
        className="ag-theme-alpine"
        style={{ height: "calc(100vh - 150px)", margin: "5px" }}
      >
        <AgGridReact
          rowData={data}
          columnDefs={columnDefs}
          rowSelection="multiple"
          animaterowData={true}
          suppressPaginationPanel={true}
          overlayNoRowsTemplate={`<span style="padding: 10px; border: var(--ag-borders) var(--ag-border-color); background: var(--ag-background-color); border-radius: var(--ag-card-radius); box-shadow: var(--ag-card-shadow);padding: var(--ag-grid-size); ">${
            !isLoading ? "" : "No Data"
          }</span>`}
          suppressScrollOnNewData={true}
          defaultColDef={defaultColDef}
        />
      </div>
      {isViewProvider && (
        <Dialog
          title="View Provider"
          style={{ background: "rgba(241, 255, 253, 0.80)" }}
          onClose={onCloseViewProvider}
        >
          <EditProvider
            selectedProviderTool={selectedProvider}
            onClose={onCloseViewProvider}
            type={"Provider"}
            setErrorMessage={setErrorMessage}
          />
        </Dialog>
      )}
      {errorMessage && <GeneralToast type="error" message={errorMessage} />}
    </>
  );
};

export default ViewProvider;
